var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Divide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 36v4H19v-4h38zm-19-6.47a3 3 0 100-6 3 3 0 000 6zm0 16.94a3 3 0 100 5.999 3 3 0 000-6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Divide.5cd29d56.svg";
export { SvgJ2Divide as ReactComponent };